import { useNavigate } from "react-router-dom";
import logo from "./Assets/cube.jpeg";

const WelcomePage = () => {
  const navigate = useNavigate();

  const handleMentalHealth = () => {
    navigate("/therapy-tool");
  };

  const handleSexualHealth = () => {
    navigate("/sexual-health");
  };

  const handleAssessment = () => {
    navigate("/self-assessment");
  };

  return (
    <div className="h-screen bg-white relative overflow-hidden flex flex-col">
      <div className="p-2 sm:p-6 flex-shrink-0">
        <div className="flex items-center gap-2 sm:gap-3">
          <img
            src={logo}
            alt="WellnessAI"
            className="w-6 h-6 sm:w-12 sm:h-12 rounded-full shadow-md"
          />
          <span className="text-base sm:text-2xl font-bold text-gray-900">
            WellnessAI
          </span>
        </div>
      </div>

      <div className="flex-1 flex flex-col justify-center px-4 sm:px-6 py-6 sm:py-8">
        <div className="text-center mb-6 sm:mb-12">
          <h1 className="text-lg sm:text-4xl md:text-7xl font-extrabold text-gray-900 mb-3 sm:mb-4 leading-tight drop-shadow-sm">
            What brings you here today?
          </h1>
          <p className="text-sm sm:text-lg md:text-2xl text-gray-600 font-medium">
            We're here to support your journey to wellness.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-10 max-w-6xl mx-auto w-full">
          <div
            onClick={handleMentalHealth}
            className="group cursor-pointer transform hover:scale-105 hover:-translate-y-1 transition-all duration-300"
          >
            <div className="bg-white rounded-xl sm:rounded-3xl shadow-xl p-4 sm:p-10 border border-purple-100 hover:shadow-2xl transition-all duration-300 text-center h-[140px] sm:min-h-[320px] flex flex-col justify-center">
              <div className="w-12 h-12 sm:w-24 sm:h-24 bg-purple-500 rounded-xl sm:rounded-3xl flex items-center justify-center shadow-lg group-hover:rotate-6 transition-all duration-300 mx-auto mb-2 sm:mb-8">
                <span className="text-2xl sm:text-5xl group-hover:scale-110 transition-transform duration-300">
                  🧠
                </span>
              </div>
              <h3 className="text-lg sm:text-3xl font-bold text-gray-900 group-hover:text-purple-700 transition-colors duration-300 mb-1 sm:mb-3">
                Mental Health
              </h3>
              <p className="text-purple-600 font-semibold text-xs sm:text-lg">
                Support & Tools
              </p>
            </div>
          </div>

          <div
            onClick={handleSexualHealth}
            className="group cursor-pointer transform hover:scale-105 hover:-translate-y-1 transition-all duration-300"
          >
            <div className="bg-white rounded-xl sm:rounded-3xl shadow-xl p-4 sm:p-10 border border-pink-100 hover:shadow-2xl transition-all duration-300 text-center h-[140px] sm:min-h-[320px] flex flex-col justify-center">
              <div className="w-12 h-12 sm:w-24 sm:h-24 bg-pink-500 rounded-xl sm:rounded-3xl flex items-center justify-center shadow-lg group-hover:rotate-6 transition-all duration-300 mx-auto mb-2 sm:mb-8">
                <span className="text-2xl sm:text-5xl group-hover:scale-110 transition-transform duration-300">
                  ❤️
                </span>
              </div>
              <h3 className="text-lg sm:text-3xl font-bold text-gray-900 group-hover:text-pink-700 transition-colors duration-300 mb-1 sm:mb-3">
                Sexual Health
              </h3>
              <p className="text-pink-600 font-semibold text-xs sm:text-lg">
                Education & Wellness
              </p>
            </div>
          </div>

          <div
            onClick={handleAssessment}
            className="group cursor-pointer transform hover:scale-105 hover:-translate-y-1 transition-all duration-300"
          >
            <div className="bg-white rounded-xl sm:rounded-3xl shadow-xl p-4 sm:p-10 border border-blue-100 hover:shadow-2xl transition-all duration-300 text-center h-[140px] sm:min-h-[320px] flex flex-col justify-center">
              <div className="w-12 h-12 sm:w-24 sm:h-24 bg-blue-500 rounded-xl sm:rounded-3xl flex items-center justify-center shadow-lg group-hover:rotate-6 transition-all duration-300 mx-auto mb-2 sm:mb-8">
                <span className="text-2xl sm:text-5xl group-hover:scale-110 transition-transform duration-300">
                  📊
                </span>
              </div>
              <h3 className="text-lg sm:text-3xl font-bold text-gray-900 group-hover:text-blue-700 transition-colors duration-300 mb-1 sm:mb-3">
                Smart Assessment
              </h3>
              <p className="text-blue-600 font-semibold text-xs sm:text-lg">
                IQ Test & more
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;